import React, { memo } from 'react';

const BigMagnifyingGlass = memo(({ size = 70 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.25">
        <path
          d="M29.983 53.3167C43.3207 53.3167 54.133 42.6872 54.133 29.575C54.133 16.4629 43.3207 5.83337 29.983 5.83337C16.6453 5.83337 5.83301 16.4629 5.83301 29.575C5.83301 42.6872 16.6453 53.3167 29.983 53.3167Z"
          stroke="#D2552B"
          strokeWidth="5"
          strokeMiterlimit="10"
        />
        <path
          d="M46.5801 46.8708L64.1676 64.1667"
          stroke="#D2552B"
          strokeWidth="5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
});

export default BigMagnifyingGlass;
